module.exports = __webpack_public_path__ + "img/external-audit.793e83e1.png";